var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRuler(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 5L6.25 19C6.25 21.42 7.58 22.75 10 22.75H14C16.42 22.75 17.75 21.42 17.75 19V5C17.75 2.58 16.42 1.25 14 1.25H10C7.58 1.25 6.25 2.58 6.25 5ZM16.25 19C16.25 20.58 15.58 21.25 14 21.25H10C8.42 21.25 7.75 20.58 7.75 19L7.75 5C7.75 3.42 8.42 2.75 10 2.75H14C15.58 2.75 16.25 3.42 16.25 5V19Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 6C11.25 6.41 11.59 6.75 12 6.75H17C17.41 6.75 17.75 6.41 17.75 6C17.75 5.59 17.41 5.25 17 5.25H12C11.59 5.25 11.25 5.59 11.25 6Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 18C12.25 18.41 12.59 18.75 13 18.75H17C17.41 18.75 17.75 18.41 17.75 18C17.75 17.59 17.41 17.25 17 17.25H13C12.59 17.25 12.25 17.59 12.25 18Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 14C11.25 14.42 11.59 14.75 12.01 14.75L17.01 14.7C17.42 14.7 17.75 14.36 17.75 13.95C17.75 13.95 17.75 13.95 17.75 13.94C17.75 13.53 17.41 13.19 16.99 13.2L11.99 13.25C11.58 13.25 11.25 13.59 11.25 14Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.25 10C13.25 10.41 13.59 10.75 14 10.75H17C17.41 10.75 17.75 10.41 17.75 10C17.75 9.59 17.41 9.25 17 9.25H14C13.59 9.25 13.25 9.59 13.25 10Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRuler);
export default __webpack_public_path__ + "static/media/ruler.d68bcebcc6ad346c47a48c878be79fe3.svg";
export { ForwardRef as ReactComponent };